import { SafeUrl } from "@angular/platform-browser";
import "./../util/ArrayExtensions";
import { MatTableDataSource } from "@angular/material/table";

// ********************************************************************************
// #region Classes
// ********************************************************************************

export interface IEntity
{
  id: number;
}


export class LocalStorage implements Storage
{
  [name: string]: any;
  readonly length: number;
  clear(): void { }
  getItem(key: string): string | null { return undefined; }
  key(index: number): string | null { return undefined; }
  removeItem(key: string): void { }
  setItem(key: string, value: string): void { }
}

export class UserDto
{

}

export class LoginDto
{
  id: string = "";
  password: string = "";
  cartId: string = "";
  language: string = "";
}

export interface FileInfo
{
  name: string,
  url: SafeUrl
}

export class UpdateFileDto
{
  id: number = 0;
  fileType: FileType = 0;
  fileBlobId: number = 0;
}

export class RefreshTokenDto
{
  language: string = "";
  refreshToken: string = "";
}

export class ValidateSessionDto
{
  language: string = "";
  token: string = "";
}

export class DynamicPipeType
{
  //NOTE: Must have same methods name that is inside "dynamic.pipe.ts"
  public static OrderStatus = "orderStatus";
  public static PaymentStatus = "paymentStatus"
  public static DateTime = "dateTime";
  public static Date = "date";
  public static UTCDateTime = "UTCDateTime";
  public static Currency = "currency";
  public static ToUpperCase = "toUpper";
  public static OrderPayment = "orderPayment";
}

export class Product
{
  id: number;
  name: string;
  description: string;
  isActive: boolean;
  isDeleted: boolean;
  productType: ProductType;
  alignersQuantity: number;
  quantityStock?: number;
  isCase: boolean;
  hasDentalMonitoring: boolean;
  hasUnlimitedAligners: boolean;
  category: Category;
  additionalServices?: ProductAdditionalServices;
  specList: ProductSpec[];
  principalImage?: string;
  images: ProductImage[];
  priceList: ProductPriceList[];
  itemPrices: ItemPrices;
  baseTax: number;
  basePriceProduct: number;
  basePriceExtraAligner: number;
  basePriceDentalMonitoring: number;
  basePriceComplexCase:number;
  basePriceExpander:number;
  specialProductPrice?:number;
  specialProductPriceComments?:string;

  // Precio editado de cada concepto, tal como quedó en la pantalla de captura.
  // Sin valor = se cobra el de lista.
  editedProductPrice?:number;
  editedDentalMonitoringPrice?:number;
  editedComplexCasePrice?:number;
  editedExtraAlignerPrice?:number;
  expirationTime: number;
  setupIncluded: boolean;
  sort: number;
  allowComplexCase: boolean;
  /** El paquete permite vender alineadores adicionales. El backend ya lo mandaba; faltaba aquí. */
  allowAdditionalAligners: boolean;
  nonTaxable: boolean;
  allowsInstallmentPlan?: boolean;
  alignersDefaultSinLiquidar?: number;
  installmentSurcharge30Days?: number;
  installmentSurcharge60Days?: number;
}
export class ItemPrices
{
  priceExtraAligner?: number;
  subtotal: number;
  price: number;
  priceExtraDentalMonitoring?: number;
  priceComplexCase?: number;
  priceExpander?: number;
  tax?: number;
  totalTax?: number;
  shoppingDiscount?: number;
  priceWithDiscount?: number;
}
export class Category
{
  id: number;
  parentId: number;
  name: string;
  description: string;
  subcategories: Category[];
}

export class ProductImage
{
  id: number;
  order: number;
  productId: number;
  url: string;
}

export class ServiceImage
{
  order?: number;
  url: string;
}

export class ProductSpec
{
  id: number;
  name: string;
  value: string;
  productId: number;
}

export class ProductPriceList
{
  id: number;
  priceProduct: number;
  priceExtraAligner: number;
  priceExtraDentalMonitoring: number;
  priceComplexCase: number;
  priceExpander: number;
  tax: number;
  isDeleted: boolean;
  productId: number;
  customerTypeId: number;
}

export class ProductAdditionalServices
{
  addDentalMonitoring: boolean;
  addIsComplexCase: boolean;
  addExpander?: boolean;
  hasUnlimitedAligners?: boolean;
  extraAlignersQuantity: number;
}

export class CaseStage
{
  stageNumber: number;
  upperAligners: number;
  lowerAligners: number;
  comments: string;
  frecuencyDays: number;
  startDate?: Date;
  endDate?: Date;
  isManufactured: boolean;
  isPendingToReviewAlignersQuantity?: boolean;
  totalAlignersQuantity: number;
  caseId: number;
  setupId: number;
  statusId?: number;
  isDeleted: boolean;
  selectedProducts: number[];
  productsForStageSelected: boolean;
  /** 1 nueva etapa · 2 continuación de setup · 3 reimpresión */
  stageType?: number;
  minimumAlignersOverride?: number;
  upperRangeFrom?: number;
  upperRangeTo?: number;
  lowerRangeFrom?: number;
  lowerRangeTo?: number;
}

/** Tipos de etapa: viven en src/shared/stage-types.ts, compartidos con el ecommerce. */
export { CaseStageType, CaseStageTypeLabels } from 'src/shared/stage-types';


export class Status
{
  id: number;
  name: string;
  backofficeDescription: string;
  ecommerceDescription: string;
  caseDescription: string;
  maxDays: number;
  colorOnTime: string;
  colorOffTime: string;
  order: number;
  isDeleted: boolean;
  isFinal: boolean;
  isCancelable: boolean;
  requiresSetupPayment: boolean;
  requiresSufficientAlignersAvailable: boolean;
  isSpecial: boolean;
  escapeStatusId: number;
  statusRangeId: number;
}

// #endregion Classes

// ********************************************************************************
// #region Interfaces
// ********************************************************************************

export interface IEntity
{
  id: number;
}

export interface IBaseRequest
{
  token: string;
}

export interface ICustomerLevel
{
  name: string;
  description: string;
  code: string;
  minNumberCases: number;
  maxNumberCases: number;
  shoppingDiscount: number;
  customerTypeId: number;
}

export interface IRolePermission
{
  id?: number;
  roleId: number;
  permissionId: number;
}

export interface IPermission
{
  code: string;
  name: string;
  description: string;
  order: number;
  isActive: boolean;
  isDeleted: boolean;
}
//Add base interfaces



// #endregion Interfaces

//Currency Type
export enum CurrencyTypeInt
{
  MXN = 0,
  USD = 1,
  CAD = 2,
  EUR = 3,
  GBP = 4,
  JPY = 5,
}

export enum ProductType
{
  Plan = 1,
  Setup = 2,
  Service = 3,
  Accessory = 4,
  PersonalizedAccessory = 5,
}

export enum PrescriptionType {
  RetainerFixed    = 1,
  RetainerRemovable = 2,
  GnathologicalGuard = 3,
  Herbst = 4,
  Marpe = 5,
}

export const PrescriptionTypeOptions = [
  { value: PrescriptionType.RetainerFixed,     label: 'Retenedor Fijo (BIO24k)' },
  { value: PrescriptionType.RetainerRemovable, label: 'Retenedor Removible (NX1)' },
  { value: PrescriptionType.GnathologicalGuard,label: 'Guarda Gnatológica' },
  { value: PrescriptionType.Herbst,            label: 'Herbst' },
  { value: PrescriptionType.Marpe,             label: 'MARPE' },
];

/**
 * Aparatos que se capturan con el wizard común (app-appliance-wizard). Su definición —pasos,
 * opciones, textos— vive en el backend (ApplianceDefinitions.cs); aquí solo se dice cuáles son.
 */
export const AppliancePrescriptionTypes: PrescriptionType[] = [PrescriptionType.Marpe];

export function isAppliancePrescriptionType(type: any): boolean
{
  return AppliancePrescriptionTypes.includes(type);
}

/** Aparatos que se fabrican de uno en uno por pedido: no llevan selector de cantidad. */
export function isOnePerOrderPrescriptionType(type: any): boolean
{
  return type === PrescriptionType.Herbst || isAppliancePrescriptionType(type);
}

export enum RetainerType { Fixed = 1, Removable = 2 }
export enum RetainerArches { Upper = 1, Lower = 2, Both = 3 }
export enum RetainerWireLength { TwoToTwo = 1, ThreeToThree = 2, FourToFour = 3 }
export enum RetainerPosition { Incisal = 1, Medio = 2, Gingival = 3 }

export enum HerbstUpperAppliance { TranspalatalArch = 1, Expander = 2 }
export enum DigitalScanner { Medit = 1, Cerec = 2, Carestream = 3, Trios = 4, Panda = 5, Other = 6 }
export const DigitalScannerOptions = [
  { value: DigitalScanner.Medit,      label: 'Medit' },
  { value: DigitalScanner.Cerec,      label: 'CEREC' },
  { value: DigitalScanner.Carestream, label: 'Carestream' },
  { value: DigitalScanner.Trios,      label: 'TRIOS' },
  { value: DigitalScanner.Panda,      label: 'Panda' },
  { value: DigitalScanner.Other,      label: 'Otro' },
];

//check ISO 4217 before add new one
export const CurrencyTypeCode = new Map<number, string>([
  [CurrencyTypeInt.MXN, 'MXN'],
  [CurrencyTypeInt.USD, 'USD$'],
  [CurrencyTypeInt.CAD, 'CAD'],
  [CurrencyTypeInt.EUR, 'EUR'],
  [CurrencyTypeInt.GBP, 'GBP'],
  [CurrencyTypeInt.JPY, 'JPY'],
]);

export enum FileWeirExtension
{
  STL = '.stl',
}

export enum FileApplicationType
{
  PDF = 'application/pdf',
  STL = 'application/octet-stream',
  TXT = 'application/plain',
  ZIP7 = 'application/x-7z-compressed',
  ZIP = 'application/zip',
  RAR = 'application/x-rar-compressed',
  WORD = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  POWERPOINT = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

export enum FileExtension//Agregar nuevos formatos de archivo
{
  PDF = '.pdf',
  TXT = '.txt',
  ZIP = '.zip',
  ZIP7 = '.7z',
  RAR = '.rar',
  WORD = '.docx',//
  POWERPOINT = '.pptx',//
  EXCEL = '.xlsx',//
}

export enum ImageExtension
{
  JPG = '.jpg',
  JPEG = '.jpg',
  PNG = '.png',
  GIF = '.gif',
  TIF = '.tif',
  BMP = '.bmp'
}

export enum ImageType
{
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  TIF = 'image/tiff',
  BMP = 'image/bmp'
}

export enum FileType
{
  LateralExtraoralId = 0,
  FrontalExtraoralId = 1,
  SmileExtraoralId = 2,
  UpperOcclusalId = 3,
  LowerOcclusalId = 4,
  LeftLateralIntraoralId = 5,
  FrontalIntraoralId = 6,
  RightLateralIntraoralId = 7,
  CompositeId = 8,
  PanoramicRadiographyId = 9,
  LateralRadiographyId = 10,
  AdditionalRadiographyId = 11,
  BiteSTLId = 12,
  UpperSTLId = 13,
  LowerSTLId = 14,
  AdditionalCaseFileId = 15,
  TaxInformation = 16,
  RightsAgreement = 17,
  PromiseLetter = 18,
  FiscalDocument = 19
}

export enum OrderStatus
{
  Pending = 0,
  Approved = 1,
  Canceled = 2,
}

export enum PorCobrarOrderSyncStatus
{
  Pending = 0,
  Sent = 1,
  Canceled = 2,
}

export enum PorCobrarOrderStatus{
  Pending = 2,
  Expired = 3,
  Paid = 5,
}

export enum CustomerStatus
{
  Inactivo=0,
  Activo=1,
  Pending=2
}

export enum OrderPaymentStatus {
  InProcess = 0,
  Completed = 1,
  PartialPayment = 2,
}

export enum AccessoryOrderStatus {
  Pending = 0,
  Fulfilled = 1,
  Shipped = 2,
  Canceled = 3,
  InReview = 4,
  InProduction = 5,
  Packaging = 6,
  // Solo aparatos con aprobación de diseño (MARPE...)
  InDesign = 7,
  DesignApproval = 8,
}

export const AccessoryOrderStatusLabel = new Map<number, string>([
  [AccessoryOrderStatus.Pending, 'Pendiente'],
  [AccessoryOrderStatus.Fulfilled, 'Surtido'],
  [AccessoryOrderStatus.Shipped, 'Enviado'],
  [AccessoryOrderStatus.Canceled, 'Cancelado'],
  [AccessoryOrderStatus.InReview, 'En Revisión'],
  [AccessoryOrderStatus.InProduction, 'En Fabricación'],
  [AccessoryOrderStatus.Packaging, 'Empaque'],
  [AccessoryOrderStatus.InDesign, 'En Diseño'],
  [AccessoryOrderStatus.DesignApproval, 'Diseño por Aprobar'],
]);

/**
 * Flujo de estatus de un aparato (fabricación personalizada), en el orden en que avanza. Los de
 * diseño solo aplican a aparatos con aprobación de diseño (MARPE...): van entre revisión y fabricación.
 */
export function personalizedAccessoryStatusFlow(withDesign: boolean): AccessoryOrderStatus[]
{
  return [
    AccessoryOrderStatus.Pending,
    AccessoryOrderStatus.InReview,
    ...(withDesign ? [AccessoryOrderStatus.InDesign, AccessoryOrderStatus.DesignApproval] : []),
    AccessoryOrderStatus.InProduction,
    AccessoryOrderStatus.Packaging,
    AccessoryOrderStatus.Shipped,
    AccessoryOrderStatus.Canceled,
  ];
}

/** Opciones { value, name } de una lista de estatus, con el nombre de AccessoryOrderStatusLabel. */
export function toAccessoryStatusOptions(statuses: AccessoryOrderStatus[]): { value: AccessoryOrderStatus, name: string }[]
{
  return statuses.map(s => ({ value: s, name: AccessoryOrderStatusLabel.get(s) }));
}

/** Color del chip de cada estatus; lo comparten la lista y el detalle. */
export function accessoryStatusChipClass(status: number): string
{
  switch (status) {
    case AccessoryOrderStatus.Fulfilled:      return 'chip-green';
    case AccessoryOrderStatus.Shipped:        return 'chip-blue';
    case AccessoryOrderStatus.Canceled:       return 'chip-red';
    case AccessoryOrderStatus.InReview:       return 'chip-yellow';
    case AccessoryOrderStatus.InDesign:       return 'chip-teal';
    case AccessoryOrderStatus.DesignApproval: return 'chip-indigo';
    case AccessoryOrderStatus.InProduction:   return 'chip-orange';
    case AccessoryOrderStatus.Packaging:      return 'chip-purple';
    default:                                  return 'chip-yellow';
  }
}

export interface PurchasePayment {
  id: number;
  purchaseOrderId: number;
  paymentNumber: number;
  amount: number;
  paymentMethod: string;
  paymentDate: string;
  origin: string;
  openPayTransactionId?: string;
  notes?: string;
  status: string;
  registeredById?: number;
  registeredByName?: string;
  cancelledById?: number;
  cancelledByName?: string;
  supervisorCancel: boolean;
  cancelNotes?: string;
  createdDate: string;
  outstandingBalance: number;
}

export interface PaymentMethodCatalog {
  id: number;
  name: string;
  displayOrder: number;
  isActive: boolean;
}

export enum PaymentTypeStatus
{
  OpenPay = 1,
  PayNet = 2,
  SPEI = 3,
  Paypal = 4,
  InPerson = 5,
  PayLink = 6,
  Courtesy = 7,
  CardPay = 8,
  CourtesyEvents = 9,
  CourtesyHexagon = 10,
  CourtesyWarranty = 11
}

export enum ServiceType
{
  ComplexCase = 0,
  DentalMonitoring = 1,
  AditionalAligners = 2,
  Upgrade = 3
}

export const ProductTypeLabel = new Map<number, string>([
  [ProductType.Plan, "Plan"],
  [ProductType.Setup, "Setup"],
  [ProductType.Service, "Servicio"],
  [ProductType.Accessory, "Accesorios"],
]);

export const FileTypeLabel = new Map<number, string>([
  [FileType.LateralExtraoralId, "Extraoral Lateral"],
  [FileType.FrontalExtraoralId, "Extraoral Frontal"],
  [FileType.SmileExtraoralId, "Extraoral Sonrisa"],
  [FileType.UpperOcclusalId, "Oclusal Superior"],
  [FileType.LowerOcclusalId, "Oclusal Inferior"],
  [FileType.LeftLateralIntraoralId, "Intraoral Lateral Izquierda"],
  [FileType.FrontalIntraoralId, "Intraoral Frontal"],
  [FileType.RightLateralIntraoralId, "Intraoral Lateral Derecha"],
  [FileType.CompositeId, "Composite"],
  [FileType.PanoramicRadiographyId, "Radiografía Panorámica"],
  [FileType.LateralRadiographyId, "Radiografía Lateral"],
  [FileType.AdditionalRadiographyId, "Radiografía Adicional"],
  [FileType.BiteSTLId, "Mordida y otros STL"],
  [FileType.UpperSTLId, "Superior STL"],
  [FileType.LowerSTLId, "Inferior STL"],
  [FileType.AdditionalCaseFileId, "Nuevo archivo adicional"],
  [FileType.TaxInformation, "Constancia Fiscal"],
  [FileType.RightsAgreement, "Cesión de derechos"],
  [FileType.PromiseLetter, "Carta compromiso"],
  [FileType.FiscalDocument, "Constancia de situación fiscal"]
]);

export const FileTypeName = new Map<number, string>([
  [FileType.LateralExtraoralId, "LateralExtraoral"],
  [FileType.FrontalExtraoralId, "FrontalExtraoral"],
  [FileType.SmileExtraoralId, "SmileExtraoral"],
  [FileType.UpperOcclusalId, "UpperOcclusal"],
  [FileType.LowerOcclusalId, "LowerOcclusal"],
  [FileType.LeftLateralIntraoralId, "LeftLateralIntraoral"],
  [FileType.FrontalIntraoralId, "FrontalIntraoral"],
  [FileType.RightLateralIntraoralId, "RightLateralIntraoral"],
  [FileType.CompositeId, "Composite"],
  [FileType.PanoramicRadiographyId, "PanoramicRadiography"],
  [FileType.LateralRadiographyId, "LateralRadiography"],
  [FileType.AdditionalRadiographyId, "AditionalRadiography"],
  [FileType.BiteSTLId, "BiteSTL"],
  [FileType.UpperSTLId, "UpperSTL"],
  [FileType.LowerSTLId, "LowerSTL"],
  [FileType.AdditionalCaseFileId, "AdditionalFile0"],
  [FileType.TaxInformation, "TaxInformation"],
  [FileType.RightsAgreement, "RightsAgreement"],
  [FileType.PromiseLetter, "PromiseLetter"],
  [FileType.FiscalDocument, "FiscalDocument"]
]);

export const FileTypeNamePath = new Map<number, string>([
  [FileType.LateralExtraoralId, "lateralExtraoralPath"],
  [FileType.FrontalExtraoralId, "frontalExtraoralPath"],
  [FileType.SmileExtraoralId, "smileExtraoralPath"],
  [FileType.UpperOcclusalId, "upperOcclusalPath"],
  [FileType.LowerOcclusalId, "lowerOcclusalPath"],
  [FileType.LeftLateralIntraoralId, "leftLateralIntraoralPath"],
  [FileType.FrontalIntraoralId, "frontalIntraoralPath"],
  [FileType.RightLateralIntraoralId, "rightLateralIntraoralPath"],
  [FileType.CompositeId, "compositePath"],
  [FileType.PanoramicRadiographyId, "panoramicRadiographyPath"],
  [FileType.LateralRadiographyId, "lateralRadiographyPath"],
  [FileType.AdditionalRadiographyId, "additionalRadiographyPath"],
  [FileType.BiteSTLId, "biteSTLPath"],
  [FileType.UpperSTLId, "upperSTLPath"],
  [FileType.LowerSTLId, "lowerSTLPath"],
]);

export const ProductTypeArray: any[] = [
  { key: ProductType.Plan, value: ProductTypeLabel.get(ProductType.Plan) },
  { key: ProductType.Setup, value: ProductTypeLabel.get(ProductType.Setup) },
  { key: ProductType.Accessory, value: ProductTypeLabel.get(ProductType.Accessory) },
  { key: ProductType.PersonalizedAccessory, value: 'Accesorio Personalizado' },
];

export const FileCompositeArray: any[] = [
  {
    type: FileType.LateralExtraoralId,
    label: FileTypeLabel.get(FileType.LateralExtraoralId),
    name: FileTypeName.get(FileType.LateralExtraoralId),
    fileInfo: null
  },
  {
    type: FileType.FrontalExtraoralId,
    label: FileTypeLabel.get(FileType.FrontalExtraoralId),
    name: FileTypeName.get(FileType.FrontalExtraoralId),
    fileInfo: null
  },
  {
    type: FileType.SmileExtraoralId,
    label: FileTypeLabel.get(FileType.SmileExtraoralId),
    name: FileTypeName.get(FileType.SmileExtraoralId),
    fileInfo: null
  },
  {
    type: FileType.UpperOcclusalId,
    label: FileTypeLabel.get(FileType.UpperOcclusalId),
    name: FileTypeName.get(FileType.UpperOcclusalId),
    fileInfo: null,
    isRequired: true
  },
  {
    type: FileType.CompositeId,
    label: FileTypeLabel.get(FileType.CompositeId),
    name: FileTypeName.get(FileType.CompositeId),
    fileInfo: null
  },
  {
    type: FileType.LowerOcclusalId,
    label: FileTypeLabel.get(FileType.LowerOcclusalId),
    name: FileTypeName.get(FileType.LowerOcclusalId),
    fileInfo: null,
    isRequired: true
  },
  {
    type: FileType.LeftLateralIntraoralId,
    label: FileTypeLabel.get(FileType.LeftLateralIntraoralId),
    name: FileTypeName.get(FileType.LeftLateralIntraoralId),
    fileInfo: null,
    isRequired: true
  },
  {
    type: FileType.FrontalIntraoralId,
    label: FileTypeLabel.get(FileType.FrontalIntraoralId),
    name: FileTypeName.get(FileType.FrontalIntraoralId),
    fileInfo: null,
    isRequired: true
  },
  {
    type: FileType.RightLateralIntraoralId,
    label: FileTypeLabel.get(FileType.RightLateralIntraoralId),
    name: FileTypeName.get(FileType.RightLateralIntraoralId),
    fileInfo: null,
    isRequired: true
  },
];

export const FileSingleCompositeArray: any[] = [
  {
    type: FileType.CompositeId,
    label: FileTypeLabel.get(FileType.CompositeId),
    name: FileTypeName.get(FileType.CompositeId),
    fileInfo: null
  },
];

export const FileRadiographyArray: any[] = [
  {
    type: FileType.LateralRadiographyId,
    label: FileTypeLabel.get(FileType.LateralRadiographyId),
    name: FileTypeName.get(FileType.LateralRadiographyId),
    fileInfo: null
  },
  {
    type: FileType.PanoramicRadiographyId,
    label: FileTypeLabel.get(FileType.PanoramicRadiographyId),
    name: FileTypeName.get(FileType.PanoramicRadiographyId),
    fileInfo: null
  },
  {
    type: FileType.AdditionalRadiographyId,
    label: FileTypeLabel.get(FileType.AdditionalRadiographyId),
    name: FileTypeName.get(FileType.AdditionalRadiographyId),
    fileInfo: null
  },
];

export const FileSTLArray: any[] = [
  {
    type: FileType.UpperSTLId,
    label: FileTypeLabel.get(FileType.UpperSTLId),
    name: FileTypeName.get(FileType.UpperSTLId),
    fileInfo: null
  },
  {
    type: FileType.LowerSTLId,
    label: FileTypeLabel.get(FileType.LowerSTLId),
    name: FileTypeName.get(FileType.LowerSTLId),
    fileInfo: null
  },
  {
    type: FileType.BiteSTLId,
    label: FileTypeLabel.get(FileType.BiteSTLId),
    name: FileTypeName.get(FileType.BiteSTLId),
    fileInfo: null
  },
];

export const FileAdditionalArray =
{
  Id: 0,
  type: FileType.AdditionalCaseFileId,
  label: FileTypeLabel.get(FileType.AdditionalCaseFileId),
  name: FileTypeName.get(FileType.AdditionalCaseFileId),
  fileInfo: null
};

export const AdditionalCustomerFilesArray: any[] = [
  {
    type: FileType.RightsAgreement,
    label: FileTypeLabel.get(FileType.RightsAgreement),
    name: FileTypeName.get(FileType.RightsAgreement),
    fileInfo: null
  },
  {
    type: FileType.PromiseLetter,
    label: FileTypeLabel.get(FileType.PromiseLetter),
    name: FileTypeName.get(FileType.PromiseLetter),
    fileInfo: null
  },
  {
    type: FileType.FiscalDocument,
    label: FileTypeLabel.get(FileType.FiscalDocument),
    name: FileTypeName.get(FileType.FiscalDocument),
    fileInfo: null
  }
];

export const OrderStatusLabel = new Map<number, string>([
  [OrderStatus.Pending, "Recibida / Stock no disponible"],
  [OrderStatus.Approved, "Disponible en stock / Asignada"],
  [OrderStatus.Canceled, "Cancelada"],
]);

export const CustomerStatusLabel = new Map<number, string>([
  [CustomerStatus.Inactivo, "Inactivo"],
  [CustomerStatus.Activo, "Activo"],
  [CustomerStatus.Pending, "Pendiente"],
]);

export const OrderPaymentStatusLabel = new Map<number, string>([
  [OrderPaymentStatus.InProcess, "Sin pagos registrados"],
  [OrderPaymentStatus.Completed, "Completado"],
  [OrderPaymentStatus.PartialPayment, "Pago parcial"],
]);

export const OrderPaymentTypeStatusLabel = new Map<number, string>([
  [PaymentTypeStatus.OpenPay, "OpenPay"],
  [PaymentTypeStatus.PayNet, "Paynet"],
  [PaymentTypeStatus.SPEI, "SPEI"],
  [PaymentTypeStatus.Paypal, "Paypal"],
  [PaymentTypeStatus.InPerson, "Pago presencial"],
  [PaymentTypeStatus.PayLink, "Link de pago"],
  [PaymentTypeStatus.Courtesy, "Cortesía Comercial"],
  [PaymentTypeStatus.CardPay, "Pago con terminal"],
  [PaymentTypeStatus.CourtesyEvents, "Cortesía Eventos"],
  [PaymentTypeStatus.CourtesyHexagon, "Cortesía Hexagon"],
  [PaymentTypeStatus.CourtesyWarranty, "Cortesía Garantía"]
]);

export const OrderStatusArray: any[] = [
  { value: "", name: "Todos los estatus" },
  { value: OrderStatus.Pending, name: OrderStatusLabel.get(OrderStatus.Pending) },
  { value: OrderStatus.Approved, name: OrderStatusLabel.get(OrderStatus.Approved) },
  { value: OrderStatus.Canceled, name: OrderStatusLabel.get(OrderStatus.Canceled) },
];

export const CustomerStatusArray: any[] = [
  { value: "", name: "Todos los estatus" },
  { value: CustomerStatus.Inactivo, name: CustomerStatusLabel.get(CustomerStatus.Inactivo) },
  { value: CustomerStatus.Activo, name: CustomerStatusLabel.get(CustomerStatus.Activo) },
  { value: CustomerStatus.Pending, name: CustomerStatusLabel.get(CustomerStatus.Pending) },
];

export const AccessoryOrderStatusArray: any[] = [
  { value: '', name: 'Todos los estatus' },
  { value: AccessoryOrderStatus.Pending, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.Pending) },
  { value: AccessoryOrderStatus.Fulfilled, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.Fulfilled) },
  { value: AccessoryOrderStatus.Shipped, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.Shipped) },
  { value: AccessoryOrderStatus.Canceled, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.Canceled) },
  { value: AccessoryOrderStatus.InReview, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.InReview) },
  { value: AccessoryOrderStatus.InProduction, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.InProduction) },
  { value: AccessoryOrderStatus.Packaging, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.Packaging) },
  { value: AccessoryOrderStatus.InDesign, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.InDesign) },
  { value: AccessoryOrderStatus.DesignApproval, name: AccessoryOrderStatusLabel.get(AccessoryOrderStatus.DesignApproval) },
];

export const OrderPaymentStatusArray: any[] = [
  { value: "", name: "Todos los estatus" },
  { value: OrderPaymentStatus.InProcess, name: OrderPaymentStatusLabel.get(OrderPaymentStatus.InProcess) },
  { value: OrderPaymentStatus.Completed, name: OrderPaymentStatusLabel.get(OrderPaymentStatus.Completed) },
  { value: OrderPaymentStatus.PartialPayment, name: OrderPaymentStatusLabel.get(OrderPaymentStatus.PartialPayment) },
];

export const OrderPaymentTypeStatusArray: any[] = [
  { value: PaymentTypeStatus.OpenPay, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.OpenPay) },
  { value: PaymentTypeStatus.PayNet, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.PayNet) },
  { value: PaymentTypeStatus.SPEI, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.SPEI) },
  { value: PaymentTypeStatus.InPerson, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.InPerson) },
  { value: PaymentTypeStatus.PayLink, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.PayLink) },
  { value: PaymentTypeStatus.Courtesy, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.Courtesy) },
  { value: PaymentTypeStatus.CardPay, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.CardPay) },
  { value: PaymentTypeStatus.CourtesyEvents, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.CourtesyEvents) },
  { value: PaymentTypeStatus.CourtesyHexagon, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.CourtesyHexagon) },
  { value: PaymentTypeStatus.CourtesyWarranty, name: OrderPaymentTypeStatusLabel.get(PaymentTypeStatus.CourtesyWarranty) }
];

export const PorCobrarOrderSyncStatusLabel = new Map<number, string>([
  [PorCobrarOrderSyncStatus.Pending, "Pendiente"],
  [PorCobrarOrderSyncStatus.Sent, "Enviada"],
  [PorCobrarOrderSyncStatus.Canceled, "Cancelada"],
]);

export const PorCobrarOrderStatusLabel = new Map<number, string>([
  [PorCobrarOrderStatus.Pending, "Pendiente"],
  [PorCobrarOrderStatus.Expired, "Vencida"],
  [PorCobrarOrderStatus.Paid, "Pagada"],
]);

//Product

export enum FileTypeProduct {
  principal = 0,
  secundaria = 1,
  terciaria = 2,
}
export const FileTypeProductLabel = new Map<number, string>([
  [FileTypeProduct.principal, "Fotografí­a Principal"],
  [FileTypeProduct.secundaria, "Fotografí­a Secundaria"],
  [FileTypeProduct.terciaria, "Fotografí­a Terciaria"],
]);
export const FileTypeProductName = new Map<number, string>([
  [FileTypeProduct.principal, "Principal"],
  [FileTypeProduct.secundaria, "Secundaria"],
  [FileTypeProduct.terciaria, "Terciaria"],
]);
export const FileTypeProductNamePath = new Map<number, string>([
  [FileTypeProduct.principal, "PrincipalPath"],
  [FileTypeProduct.secundaria, "SecundariaPath"],
  [FileTypeProduct.terciaria, "TerciariaPath"],
]);
export const FileProductArray: any[] = [
  {
    type: FileTypeProduct.principal,
    label: FileTypeProductLabel.get(FileTypeProduct.principal),
    name: FileTypeProductName.get(FileTypeProduct.principal),
    fileInfo: null,
    blobId: null,
    productImageId: null
  },
  {
    type: FileTypeProduct.secundaria,
    label: FileTypeProductLabel.get(FileTypeProduct.secundaria),
    name: FileTypeProductName.get(FileTypeProduct.secundaria),
    fileInfo: null,
    blobId: null,
    productImageId: null
  },
  {
    type: FileTypeProduct.terciaria,
    label: FileTypeProductLabel.get(FileTypeProduct.terciaria),
    name: FileTypeProductName.get(FileTypeProduct.terciaria),
    fileInfo: null,
    blobId: null,
    productImageId: null
  },
];
export class UpdateFileProductImage
{
  id: number = 0;
  order: FileType = 0;
  productId: number = 0;
  blobId: number = 0;
}

export class ShoppingCartItem
{
  public item: Product;
  public quantity: number;
  public customerId?:number;
  public userId?:number;
  public total?:number;
  public totalBeforeEdit?:number;
}

export enum SetupType
{
  Both = 0,
  Upper = 1,
  Lower = 2
}

/** Espejo de PrescriptionOrigin en C#. Mismo valor en ambos lados. */
export enum PrescriptionOrigin
{
  Traditional = 1,
  Voice = 2
}

export enum FileUploadType {
  CSV = 'text/csv',
}

export enum StatusRangesAssignedToRoleType
{
    Supervision = 1,
    SelfAssignment = 2,
}

export class MatTableDataSetItem
{
  public displayedColumns: any[];
  public dataSource: MatTableDataSource<any>;
  public name: string;
  public columnsToDisplay: any[];
}

export enum FCSBSFilter {
  Last30Days = 1,
  FromYearBeginningToToday = 2,
  PreviousYear = 3,
  PreviousMonth = 4,
  CurrentMonth = 5,
  Customized = 6
}